import { render, staticRenderFns } from "./UserManagementView.vue?vue&type=template&id=d6a15c88&"
import script from "./UserManagementView.vue?vue&type=script&lang=ts&"
export * from "./UserManagementView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports